import { get, getUrlQueryParameterFromObject } from 'frontcore/utils/communications/apiClient'
import { usePerimeterStore } from "frontcore/store/usePerimeterStore"

const URL_ACTIONS_STATS = 'actions'
const URL_AUDITS_STATS = 'audits'
const URL_PERIMETERS_STATS = 'perimeters'
const URL_PROBLEMS_STATS = 'problems'
const URL_SKILL_MATRIX_STATS = 'skill-matrix'
const URL_STANDARDS_STATS = 'standards'
const URL_BASE_STATS = 'stats'
const URL_FOSE_STATS = 'foses'
const URL_VARIANT_STATS = 'variants'
const URL_TASK_MANAGER_STATS = 'task-manager'
const URL_BASE_STANDARD_REVIEW = 'standard-reviews'
const URL_DR_CHECKPOINTS_STATS = 'daily-round-checkpoints'
const URL_SELF_ASESSMENTS_STATS = 'self-assessments'
const URL_GW_CHECKPOINTS_STATS = 'gemba-walk'
const URL_BASE_PROBLEM_COLLECTED_AVERAGE_CLOSURE_TIME_STATS = 'problems/collected/average-closure-time'
const URL_BASE_PROBLEM_COLLECTED_NO_PILOT_STATS = 'problems/collected/no-pilot'
const URL_BASE_OLDEST_PROBLEMS_STATS = 'problems/oldest'
const URL_BASE_CREATED_PROBLEMS_PER_PILOT_STATS = 'problems/open-per-pilot'
const URL_BASE_PROBLEM_COLLECTED_OPEN_STATS = 'problems/collected/open'
const URL_BASE_PROBLEM_COLLECTED_NO_CLOSE_DATE_STATS = 'problems/collected/no-close-date'
const URL_BASE_PROBLEM_EVOLUTION_STATS = 'problems/evolution'
const URL_BASE_PROBLEM_STATUS_STATS = 'problems/status'
const URL_BASE_PROBLEM_ONGOING_PER_PILOT_STATS = 'problems/ongoing-per-pilot'

export function getAuditAssessmentTable (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/assessment_table/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditLatest (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/collected/latest/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditAverageTimeInBetween (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/collected/average_time_in_between/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditTotaReferenceStates (filters) {
  let url = `${URL_BASE_STATS}/${URL_PERIMETERS_STATS}/collected/total_reference_states/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditCompliantRate (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/collected/compliant-rate/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getFiveSConformityRate (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/fives-conformity-rate/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getCompletedAuditsPercentage (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/completed_audits_percentage/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetTotals (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/totals/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetAverage (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/average/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetAverages (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/averages/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetAveragesChart (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/averages_charts/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetAveragesByFamily (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/average_by_family/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetAverageScoreByFamilySpiderChart (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/average_score_by_family/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditDatasetNonComplianceByFamily (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/non_compliance_by_family/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditOperatorComplianceTable (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/compliance_table/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getActionsStatsForAudits (filters) {
  let url = `${URL_BASE_STATS}/${URL_ACTIONS_STATS}/${URL_AUDITS_STATS}/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getActionsCreatedClosedForAudits (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/actions_chart/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditsWorstCriteriaDataset (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/collected/worst_criteria/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getAuditLatestBelowScoreGoal (filters) {
  let url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/collected/latest_below_score_goal/?`
  url += getUrlQueryParameterFromObject(filters, false)
  return get(url)
}

export function getComplianceActionsDeadlinesStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_AUDITS_STATS}/datasets/compliance-actions-deadlines/?${queryParams}`
  return get(url)
}


export function getActionsStats (parameters) {
  let url = `${URL_BASE_STATS}/${URL_ACTIONS_STATS}/?`
  url += getUrlQueryParameterFromObject(parameters, false)
  return get(url)
}

export function getActionsCollectedStats (perimeterIds) {
  const url = `${URL_BASE_STATS}/${URL_ACTIONS_STATS}/collected/?perimeters=${perimeterIds.join(',')}`
  return get(url)
}

export function getActionsTeamsStats (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_STATS}/${URL_ACTIONS_STATS}/teams/?${queryParams}`
  return get(url)
}

export function getActionsByPeopleStats (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_STATS}/${URL_ACTIONS_STATS}/people-visibility/?${queryParams}`
  return get(url)
}

export function getAlertsStats (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_STATS}/alerts/open-closed/?${queryParams}`
  return get(url)
}

export function getTop5AlertsStats (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_STATS}/alerts/top5/?${queryParams}`
  return get(url)
}

export function getRMAlertsStats (perimeterIds, from = null, to = null, openAlerts = true, controllersIds = []) {
  let url = 'stats/risk-product-alerts/?' +
    `&perimeters=${perimeterIds.join(',')}` +
    '&open_alerts=' + openAlerts +
    `&controllers=${controllersIds.join(',')}`

  if (from) { url += '&from=' + from }
  if (to) { url += '&to=' + to }
  return get(url)
}

export function getCommonNonCompliances (filters) {
  let url = `${URL_BASE_STATS}/${URL_TASK_MANAGER_STATS}/common-non-compliances`
  const params = getUrlQueryParameterFromObject(filters)
  url += params ? '/?' + params : null
  return get(url)
}

export function getGroupedTasksByTemporality (payload) {
  const params = getUrlQueryParameterFromObject(payload)
  const url = `${URL_BASE_STATS}/${URL_TASK_MANAGER_STATS}/grouped-assessments/?${params}`
  return get(url)
}

export function getTaskManagerActionDataset (filters) {
  let url = `${URL_BASE_STATS}/${URL_TASK_MANAGER_STATS}/datasets/actions`
  const params = getUrlQueryParameterFromObject(filters)
  url += params ? '/?' + params : null
  return get(url)
}

export function getTaskManagerNonCompliances (filters) {
  let url = `${URL_BASE_STATS}/${URL_TASK_MANAGER_STATS}/datasets/non-compliances`
  const params = getUrlQueryParameterFromObject(filters)
  url += params ? '/?' + params : null
  return get(url)
}

export function getComplianceEvaluationReasonsStats (perimeterIds) {
  let url = `${URL_BASE_STATS}/${URL_SKILL_MATRIX_STATS}/common-evaluation-reasons/?`
  if (perimeterIds) { url += `perimeters=${perimeterIds.join(',')}` }
  return get(url)
}

function getUrlParamsProblemFilters (url, payload) {
  const perimeterIds = 'perimeterIds' in payload && !usePerimeterStore().areAllPerimetersSelected ? payload['perimeterIds'] : []
  const parameters = {
    perimeters: perimeterIds,
    from: payload['from'],
    to: payload['to'],
    closed_date_from: payload['closed_date_from'],
    closed_date_to: payload['closed_date_to'],
    created_from: payload['created_from'],
    created_to: payload['created_to'],
    close_due_date_from: payload['close_due_date_from'],
    close_due_date_to: payload['close_due_date_to'],
    occurrence_date_from: payload['occurrence_date_from'],
    occurrence_date_to: payload['occurrence_date_to'],
    pilots: payload['pilotIds'],
    priorities: payload['priorityIds'],
    problem_type: payload['problemTypeIds'],
    participants: payload['participantIds'],
    supervisors: payload['supervisorIds'],
    categories: payload['categories'],
    escalated: payload['escalated'],
    recurrents: payload['recurrents'],
    not_presented: payload['not_presented'],
    problem_without_description: payload['problem_without_description'],
    problem_without_analysis: payload['problem_without_analysis'],
    problem_keywords_groups: payload['problem_keywords_groups'],
    rootcause_keywords_groups: payload['rootcause_keywords_groups'],
    problem_without_future_planning_date: payload['problem_without_future_planning_date'],
  }
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  return `${url}${queryParams}`
}

export function getProblemTotalsStats (perimeterIds, from = null, to = null, frequency = null) {
  let url = `${URL_BASE_STATS}/${URL_PROBLEMS_STATS}/datasets/totals/?perimeters=${perimeterIds.join(',')}`
  if (frequency) { url += '&frequency=' + frequency }
  if (from) { url += '&from=' + from }
  if (to) { url += '&to=' + to }
  return get(url)
}

export function _getProblemsStatsURL (baseURL, payload, frequency = 'monthly') {
  const url = `${URL_BASE_STATS}/${baseURL}/?frequency=${frequency}&`
  return getUrlParamsProblemFilters(url, payload)
}

export function getProblemsCollectedAverageClosureTimeStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_COLLECTED_AVERAGE_CLOSURE_TIME_STATS, payload, frequency)
  return get(url)
}

export function getProblemsCollectedNoPilotStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_COLLECTED_NO_PILOT_STATS, payload, frequency)
  return get(url)
}

export function getProblemsCollectedOpenStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_COLLECTED_OPEN_STATS, payload, frequency)
  return get(url)
}

export function getProblemsCollectedNoCloseDateStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_COLLECTED_NO_CLOSE_DATE_STATS, payload, frequency)
  return get(url)
}

export function getProblemsEvolutionStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_EVOLUTION_STATS, payload, frequency)
  return get(url)
}

export function getProblemsStatusStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_STATUS_STATS, payload, frequency)
  return get(url)
}

export function getProblemsOngoingPerPilotStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_PROBLEM_ONGOING_PER_PILOT_STATS, payload, frequency)
  return get(url)
}

export function getOldestProblemsKPIStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_OLDEST_PROBLEMS_STATS, payload, frequency)
  return get(url)
}

export function getCreatedProblemsPerPilotKPIStats (payload, frequency = 'monthly') {
  const url = _getProblemsStatsURL(URL_BASE_CREATED_PROBLEMS_PER_PILOT_STATS, payload, frequency)
  return get(url)
}

export function getStandardStats (perimeterIds, frequency, from, to) {
  let url = `${URL_BASE_STATS}/${URL_STANDARDS_STATS}/?` +
    `frequency=${frequency}` +
    `&from=${from}` +
    `&perimeters=${perimeterIds.join(',')}`
  if (to) { url += '&to=' + to }
  return get(url)
}

export function getStandardCollectedStats (perimeterIds, frequency, from, to) {
  const url = `${URL_BASE_STATS}/${URL_STANDARDS_STATS}/collected/?` +
              `frequency=${frequency}` +
              `&from=${from}` +
              `&to=${to}` +
              `&perimeters=${perimeterIds.join(',')}`
  return get(url)
}

export function getVirtualTrainingStats (perimeterIds, variantId, isVTAutonomous) {
  let url = `${URL_BASE_STATS}/${URL_VARIANT_STATS}/?`
  if (perimeterIds) { url += `&perimeters=${perimeterIds.join(',')}` }
  if (variantId) { url += `&variant_id=${variantId}` }
  if (isVTAutonomous) { url += `&vt_autonomous=${isVTAutonomous}` }
  return get(url)
}

export function getVirtualTrainingWorkstationStats (perimeterIds) {
  let url = `${URL_BASE_STATS}/${URL_FOSE_STATS}/?`
  if (perimeterIds) { url += `&perimeters=${perimeterIds.join(',')}` }
  return get(url)
}

export function getKeypointsReviewed (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/keypoints-reviewed/?${queryParams}`
  return get(url)
}

export function getSWAActionsStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/swr-actions/?${queryParams}`
  return get(url)
}

export function getRewiewsWithActions (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/reviews-with-actions/?${queryParams}`
  return get(url)
}

export function getStandardsVariability (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/swr-variability/?${queryParams}`
  return get(url)
}

export function getSWRStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/standard-reviews/?${queryParams}`
  return get(url)
}

export function getSWRActionsStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_BASE_STANDARD_REVIEW}/datasets/standard-reviews-with-actions/?${queryParams}`
  return get(url)
}

export function getStatsGembaWalkAlerts (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_GW_CHECKPOINTS_STATS}/datasets/gw-alerts-by-level/?${queryParams}`
  return get(url)
}

export function getStatsGembaWalkAssessmentsByDate (checkPointId) {
  const url = `${URL_BASE_STATS}/${URL_GW_CHECKPOINTS_STATS}/datasets/gw-assessments-by-date/?check_point=${checkPointId}`
  return get(url)
}

export function getStatsGembaWalkNoks (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_GW_CHECKPOINTS_STATS}/datasets/gw-checkpoint-noks/?${queryParams}`
  return get(url)
}

export function getStatsGembaWalksCount (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_GW_CHECKPOINTS_STATS}/datasets/gemba-walks/?${queryParams}`
  return get(url)
}

export function getStatsGembaWalkTrend (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_GW_CHECKPOINTS_STATS}/datasets/historical-assessment/?${queryParams}`
  return get(url)
}

export function getDailyRoundsStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_DR_CHECKPOINTS_STATS}/datasets/daily-rounds/?${queryParams}`
  return get(url)
}

export function getWeeklyMeetingsStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_DR_CHECKPOINTS_STATS}/datasets/weekly-meetings/?${queryParams}`
  return get(url)
}

export function getActivityTimeStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_DR_CHECKPOINTS_STATS}/datasets/activity-time/?${queryParams}`
  return get(url)
}

export function getFunctionsStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_SELF_ASESSMENTS_STATS}/datasets/score-by-functions/?${queryParams}`
  return get(url)
}

export function getCurrentTargetStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_SELF_ASESSMENTS_STATS}/datasets/score-per-months/?${queryParams}`
  return get(url)
}

export function getNumberOfZerosStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${URL_BASE_STATS}/${URL_SELF_ASESSMENTS_STATS}/datasets/zeros-per-months/?${queryParams}`
  return get(url)
}
